import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { appConfig } from '../../owner.config';
import { Observable } from 'rxjs';
import { AnimalResponse } from '../models/branding.interface';
import {
  OwnerModel,
  OwnerUpdateRequest,
} from '../../../../petszel-shared/src/lib/shared-models/owner.model';
import { LatestToSModel } from '../shared-store/selected-variables/selected-variables.reducer';

@Injectable({
  providedIn: 'root',
})
export class OwnerFamilyService {
  public token = localStorage.getItem('token');
  public headers: HttpHeaders;

  constructor(private http: HttpClient) {
    if (this.token) {
      this.headers = new HttpHeaders().set(
        'Authorization',
        `Bearer ${this.token}`
      );
    } else {
      this.headers = new HttpHeaders();
    }
  }

  getAnimalInfo(): Observable<AnimalResponse[]> {
    const url = `${appConfig.apiUrl}Owner/Animals`;
    return this.http.get<AnimalResponse[]>(url, { headers: this.headers });
  }

  getAnimals(): Observable<AnimalResponse[]> {
    const url = `${appConfig.apiUrl}Owner/AnimalsForAllOwners`;
    return this.http.get<AnimalResponse[]>(url, { headers: this.headers });
  }

  getAnimalProfile(petszelAnimalId: string, petszelOwnerId: string) {
    const url = `${appConfig.apiUrl}Owner/Animals/${petszelAnimalId}`;
    return this.http.get(url, {
      headers: this.headers,
      params: { petszelOwnerId },
    });
  }

  getDogBreed() {
    const url = `${appConfig.apiUrl}PetszelConstants/Breeds/Dog`;
    return this.http.get(url, { headers: this.headers });
  }

  getCatBreed() {
    const url = `${appConfig.apiUrl}PetszelConstants/Breeds/Cat`;
    return this.http.get(url, { headers: this.headers });
  }

  putNewPetInfo(formData: any) {
    const url = `${appConfig.apiUrl}Owner/Animals`;
    return this.http.put(url, formData, { headers: this.headers });
  }

  getOwnerInfo(): Observable<OwnerModel> {
    const url = `${appConfig.apiUrl}Owner`;
    return this.http.get<OwnerModel>(url, { headers: this.headers });
  }

  putOwnerInfo(ownerData: OwnerUpdateRequest): Observable<any> {
    const url = `${appConfig.apiUrl}Owner`;
    return this.http.put(url, ownerData, { headers: this.headers });
  }

  postPassword(data: any): Observable<any> {
    const url = `${appConfig.apiUrl}Owner/ChangePassword`;
    return this.http.post(url, data, { headers: this.headers });
  }

  getMicrochipCompanies(): Observable<string[]> {
    const url = `${appConfig.apiUrl}PetszelConstants/MicrochipCompanies`;
    return this.http.get<string[]>(url);
  }

  postEmail(data: any): Observable<string> {
    return this.http.post(`${appConfig.apiUrl}Owner/ChangeEmail`, data, {
      headers: this.headers,
      responseType: 'text',
    });
  }

  setDefaultPetPhoto(petId: string, payload: any): Observable<any> {
    const url = `${appConfig.apiUrl}Owner/Animals/${petId}/Photo`;
    return this.http.put(url, payload, { headers: this.headers });
  }

  putOwnerIdInfo(ownerData: OwnerModel): Observable<any> {
    const petszelOwnerId = ownerData.id;
    const url = `${appConfig.apiUrl}Owner/Owners/${petszelOwnerId}`;
    return this.http.put(url, ownerData, { headers: this.headers });
  }

  getOwnersInfo(): Observable<any> {
    const url = `${appConfig.apiUrl}Owner/Owners`;
    return this.http.get(url, { headers: this.headers });
  }

  getLatestToS(): Observable<LatestToSModel> {
    return this.http.get<LatestToSModel>(
      `${appConfig.apiUrl}Owner/TermsOfService/Latest/Owner`,
      { headers: this.headers }
    );
  }

  manualTextOptIn(petszelOwnerId: string) {
    const url = `${appConfig.apiUrl}Owner/ManualTextOptIn`;
    const params = new HttpParams().set('petszelOwnerId', petszelOwnerId);
    return this.http.put(url, null, {
      headers: this.headers,
      params,
      observe: 'response',
      responseType: 'text',
    });
  }
}
